import React from 'react';
import { Button, ButtonGroup } from 'react-bootstrap';
import Datetime from 'react-datetime';
import Select from 'react-select';
import moment from 'moment';
import 'moment/locale/tr';
import DomesticArea from '../../../components/domestic/area';
import AbroadArea from '../../../components/abroad/area';
import { trTravelReasons,enTravelReasons } from '../../../mock/travel-reasons';
import { ABROAD, DOMESTIC } from '../../../constants/variables';
import getCurrencySymbol from '../../../constants/currencies';
import { withNamespaces } from 'react-i18next';
import swal from "sweetalert2";

class RequestItem extends React.Component {
  constructor(props) {
    super(props);

    this.changeType = this.changeType.bind(this);
    this.checkDateIsValid = this.checkDateIsValid.bind(this);
    this.togglePanel = this.togglePanel.bind(this);
    this.changeTravelStartDate = this.changeTravelStartDate.bind(this);
    this.changeTravelStartHour = this.changeTravelStartHour.bind(this);
    this.changeTravelEndDate = this.changeTravelEndDate.bind(this);
    this.changeTravelEndHour = this.changeTravelEndHour.bind(this);
    this.changeDescription = this.changeDescription.bind(this);
    this.changeEventHandler = this.changeEventHandler.bind(this);
    this.changeTravelReasons = this.changeTravelReasons.bind(this);
    this.changeIndividualAccommodation = this.changeIndividualAccommodation.bind(this);
    this.changeIndividualAccommodationDays = this.changeIndividualAccommodationDays.bind(this);
    this.state = {
      isOpen: false,
      isAlertShown: false,
    };
  }



  componentDidMount() {
    const { i18n } = this.props;
    moment.locale(i18n.language === 'en' ? 'en' : 'tr');
  }
  componentWillMount() {
    const { open, changeRequest ,t, language} = this.props;
    if (open) {
      this.setState({ isOpen: open, checkDayCount: false });
    }
    changeRequest({
      name: t("travelExpense"),
      validation: { isValid: true, message: null },
      type: DOMESTIC,
      travelStartDate: moment.unix() * 1000,
      travelStartHour: null,
      travelEndDate: moment.unix() * 1000,
      travelEndHour: null,
      travelReasons: [],
      description: '',
      guessAmount: '',
      domestic: {
        provinces: [],
      },
      abroad: {
        region: null,
        country: null,
        visa: {
          value: '',
        },
        passportNo: '',
        roadFriends: null,
        workStartDate: null,
        workStartHour: null,
        isPasaportRequired:false,
      },
      individualAccommodation: false,
      individualAccommodationDays: 0,
      calculatedAmount: {},
      harcirahIleriyeDonukKontrolVarMi: false,
    });
  }
 componentDidUpdate(prevProps) {
   const {request ,t, language, changeRequest,i18n} = this.props;
   if (prevProps.i18n.language !== i18n.language) {
     moment.locale(language === 'en' ? 'en' : 'tr');
   }
   if(prevProps.language !== language){
    changeRequest({
      ...request,
      name: t("travelExpense")
    });
   }
   if (prevProps && prevProps.request && prevProps.request.travelReasons) {
     const prevCheckDayCount = prevProps.request.travelReasons.some(r => r.value === '7' || r.value === '5');
     const currentCheckDayCount = request.travelReasons && request.travelReasons.some(r => r.value === '7' || r.value === '5');

     if (!currentCheckDayCount && prevCheckDayCount) {
       this.setState({ isAlertShown: false });
     }
   }
 }

  checkDateIsValid(current) {
    const { configuration, request, harcirahGrup } = this.props;
    const {
      abroadRetroactiveDayLimit,passportVisaRequired
      ,abroadProspectiveDayLimit, domesticRetroactiveDayLimit, domesticProspectiveDayLimit
    } = configuration;

    const yurtIciIleri = domesticProspectiveDayLimit;
    const yurtIciGeri = domesticRetroactiveDayLimit;
    const yurtDisiIleri = abroadProspectiveDayLimit;
    const yurtDisiGeri = abroadRetroactiveDayLimit;
    const isPasaportValid = passportVisaRequired;

    request.yurtIciIleri = yurtIciIleri;
    request.yurtIciGeri = yurtIciGeri;
    request.yurtDisiIleri = yurtDisiIleri;
    request.yurtDisiGeri = yurtDisiGeri;
    request.harcirahGrup = harcirahGrup;
    request.abroad.isPasaportRequired = isPasaportValid;


    if (yurtIciIleri > 0) {
      const harcirahIleriyeDonukKontrolVarMi = true; // ileri yurtiçi girebilir

      request.harcirahIleriyeDonukKontrolVarMi = harcirahIleriyeDonukKontrolVarMi;
    }

    if (request.type === DOMESTIC) {
      const day = yurtIciGeri + 1;
      const checkedDate = Datetime.moment().subtract(day, 'day');
      const checkedDomesticNextDay = Datetime.moment().add(yurtIciIleri, 'day'); // ileri

      if (current.isAfter(checkedDate) === true) { // ileri sınırlama
        return current.isBefore(checkedDomesticNextDay);
      }

      return current.isAfter(checkedDate);
    }

    if (request.type === ABROAD) {
      const day = yurtDisiGeri + 1;
      const checkedDate = Datetime.moment().subtract(day, 'day');
      const checkedDomesticNextDay = Datetime.moment().add(yurtDisiIleri, 'day'); // ileri

      if (current.isAfter(checkedDate) === true) { // ileri
        return current.isBefore(checkedDomesticNextDay);
      }

      return current.isAfter(checkedDate);
    }

    return true;
  }

  changeType(type) {
    const { request, changeRequest } = this.props;


    if (type !== request.type) {
      request.abroad.country = null;
      request.calculatedAmount = {};
    }

    changeRequest({ ...request, type });
  }

  togglePanel() {
    const { isOpen } = this.state;

    this.setState({ isOpen: !isOpen });
  }

  changeTravelStartDate(momentDate) {
    const { request, changeRequest } = this.props;

    if (moment.isMoment(momentDate)) {
      const convertToUnixtime = momentDate.unix() * 1000;
      let payload = {};

      if (convertToUnixtime <= request.travelEndDate) {
        payload = { ...request, travelStartDate: convertToUnixtime };
        changeRequest(payload);
      } else {
        payload = {
          ...request,
          travelStartDate: convertToUnixtime,
          travelEndDate: convertToUnixtime,
        };
        changeRequest(payload);
      }
    }
  }

  changeTravelStartHour(momentDate) {
    const { request, changeRequest, hoursFormat } = this.props;
    const payload = { ...request, travelStartHour: hoursFormat(momentDate) };

    changeRequest(payload);
  }

  changeTravelEndDate(momentDate) {
    const { request, changeRequest } = this.props;

    if (moment.isMoment(momentDate)) {
      const convertToUnixtime = momentDate.unix() * 1000;
      let payload = {};

      if (convertToUnixtime >= request.travelStartDate) {
        payload = { ...request, travelEndDate: convertToUnixtime };
        changeRequest(payload);
      } else {
        payload = {
          ...request,
          travelEndDate: convertToUnixtime,
          travelStartDate: convertToUnixtime,
        };
        changeRequest(payload);
      }
    }
  }

  changeTravelEndHour(momentDate) {
    const { request, changeRequest, hoursFormat } = this.props;
    const hour = hoursFormat(momentDate);
    const payload = { ...request, travelEndHour: hour };

    if (hour && hour.length === 5) {
      changeRequest(payload);
    }
  }

  changeDescription(e) {
    const { request, changeRequest } = this.props;

    changeRequest({ ...request, description: e.target.value });
  }

  changeEventHandler(e) {
     const { request, changeRequest } = this.props;
     changeRequest({ ...request, [e.target.name]: e.target.value });
  }
  changeTravelReasons(val) {
    const { request, changeRequest,t } = this.props;
    const payload = { ...request, travelReasons: val };

    const checkDayCount = payload.travelReasons.some(r => r.value === '7' || r.value === '5');
    if (checkDayCount && !this.state.isAlertShown) {
      swal({
        title: '',
        text: t("reasonForTravelWarning"),
        type: 'warning',
        showCancelButton: true,
        showConfirmButton: false,
        cancelButtonColor: '#d33',
        cancelButtonText: 'Kapat',
      }).then(function () {
        setTimeout(function(){
        }, 500);
      }).catch((e) => {
        console.log(e)
      });
      this.setState({ isAlertShown: true });
    }

    this.setState({ checkDayCount });

    changeRequest({ ...request, travelReasons: val });
  }

  changeIndividualAccommodation(value) {
    const { request, changeRequest } = this.props;
    const payload = {
      ...request,
      individualAccommodation: value,
      individualAccommodationDays: (value
        ? request.individualAccommodationDays
        : 0),
    };

    changeRequest(payload);
  }

  changeIndividualAccommodationDays(e) {
    const { request, changeRequest } = this.props;

    const value = e.target.value.replace(',', '.');
    const payload = { ...request, individualAccommodationDays: value };

    changeRequest(payload);
  }

  render() {
    const { request, deleteRequest, order,t, isOverLimitCheckExist,isPasaportRequired } = this.props;
    const { isOpen } = this.state;
    const descriptionPlaceHolder = request && request.type === ABROAD ? t("descriptionTravelDetail") : t("explanation");

    return (
      <div className="card">
        <div className="header">
          <button
            className="btn btn-xs btn-default"
            onClick={this.togglePanel}
            style={{ float: 'left', borderWidth: 1 }}
          >
            <i className={`fa ${isOpen ? 'fa-angle-down' : 'fa-angle-right'}`} />
          </button>

          <div className="col-md-11 col-xs-10" style={{ float: 'left' }}>
            <h4 className="title">
              {request.name}
              {' '}
              {(order + 1) || ''}
              {' '}
            </h4>
          </div>

          <div className="pull-right">
            <button
              className="btn btn-xs btn-danger"
              style={{ float: 'left', borderWidth: 1 }}
              onClick={deleteRequest || null}
            >
              <i className="fa fa-trash" />
            </button>
          </div>
          <br />
        </div>
        <div className="content">
          {isOpen
            ? (
              <div>
                <br />
                <ButtonGroup justified>
                  <Button
                    href="#"
                    bsClass="btn btn-success"
                    active={request.type === DOMESTIC}
                    onClick={() => this.changeType(DOMESTIC)}
                    id='domesticButton'
                  >
                    {t("domestic")}
                  </Button>
                  <Button
                    href="#"
                    bsClass="btn btn-success"
                    active={request.type === ABROAD}
                    onClick={() => this.changeType(ABROAD)}
                    id='abroadButton'
                  >
                    {t("overseas")}
                  </Button>
                </ButtonGroup>
                <hr />
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        <span className="required-field">
*
                        </span>
                        {' '} {t("travelStartDate")}
                      </label>
                      <Datetime
                        key={this.props.i18n.language}
                        locale={this.props.i18n.language === 'en' ? 'en' : 'tr'}
                        value={request.travelStartDate}
                        isValidDate={this.checkDateIsValid}
                        dateFormat="DD-MM-YYYY"
                        timeFormat={false}
                        onChange={this.changeTravelStartDate}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        <span className="required-field">
*
                        </span>
                        {' '} {t("travelStartTime")}

                      </label>
                      <Datetime
                        key={this.props.i18n.language}
                        locale={this.props.i18n.language === 'en' ? 'en' : 'tr'}
                        value={request.travelStartHour}
                        dateFormat={false}
                        timeFormat="HH:mm"
                        onChange={this.changeTravelStartHour}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        <span className="required-field">
*
                        </span>
                        {' '} {t("travelEndDate")}

                      </label>
                      <Datetime
                        key={this.props.i18n.language}
                        locale={this.props.i18n.language === 'en' ? 'en' : 'tr'}
                        value={request.travelEndDate}
                        isValidDate={this.checkDateIsValid}
                        dateFormat="DD-MM-YYYY"
                        timeFormat={false}
                        onChange={this.changeTravelEndDate}
                      />
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        <span className="required-field">
*
                        </span>
                        {' '} {t("travelEndTime")}
                      </label>
                      <Datetime
                        key={this.props.i18n.language}
                        locale={this.props.i18n.language === 'en' ? 'en' : 'tr'}
                        value={request.travelEndHour}
                        dateFormat={false}
                        timeFormat="HH:mm"
                        onChange={this.changeTravelEndHour}
                      />
                    </div>
                  </div>
                </div>
                {/* 78813 Valeo Limit Control */
                isOverLimitCheckExist ?
                <div className="form-group">
                      <label>
                        <span
                          style={{
                            visibility: true
                              ? 'visible'
                              : 'true',
                          }}
                          className="required-field"
                        >
*
                        </span>
                        {t("guessedTravelExpenseCost")}
                      </label>
                      <input
                        type="number"
                        min="0"
                        placeholder="0"
                        className="form-control border-input"
                        id="guessAmount"
                        name="guessAmount"
                        onChange={this.changeEventHandler}
                        value={request.guessAmount}
                      />
                    </div>

                :  null
              }
                { request.type === DOMESTIC
                  ? <DomesticArea {...this.props} />
                  : (
                    <AbroadArea
                      {...this.props}
                    />
                  ) }
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        <span className="required-field">
*
                        </span>
                        {' '} {t("reasonForTravel")}
                      </label>
                      <Select
                        multi
                        placeholder={t("choose")}
                        options={this.props.i18n.language === 'tr' ? trTravelReasons : enTravelReasons}
                        value={request.travelReasons}
                        onChange={this.changeTravelReasons}
                        id="travelReason"
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-12">
                    <div className="form-group">
                      <label>
                        <span className="required-field">
*
                        </span>
                        {' '} {t("explanation")}
                      </label>
                      <textarea
                        rows={5}
                        className="form-control border-input"
                        value={request.description}
                        onChange={this.changeDescription}
                        placeholder={descriptionPlaceHolder}
                        id='explanation'
                      />
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        <span className="required-field" />
                        {' '} {t("isThereAccommodation")}
                      </label>
                      <ButtonGroup justified>
                        <Button
                          href="#"
                          bsClass="btn btn-success"
                          active={!request.individualAccommodation}
                          onClick={() => this.changeIndividualAccommodation(
                            false)}
                          id='noIndividualAccommodation'
                        > {t("no")}
                        </Button>
                        <Button
                          href="#"
                          bsClass="btn btn-success"
                          active={request.individualAccommodation}
                          disabled={this.state.checkDayCount}
                          onClick={() => this.changeIndividualAccommodation(
                            true)}
                          id='thereIsIndividualAccommodation'
                        >{t("yes")}
                        </Button>
                      </ButtonGroup>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>
                        <span
                          style={{
                            visibility: !request.individualAccommodation
                              ? 'hidden'
                              : 'visible',
                          }}
                          className="required-field"
                        >
*
                        </span>
                        {' '} {t("howManyDaysAccommodation")}
                      </label>
                      <input
                        type="text"
                        className="form-control border-input"
                        placeholder="Gün sayısı giriniz"
                        value={this.state.checkDayCount ? 0 : request.individualAccommodationDays}
                        onChange={this.changeIndividualAccommodationDays}
                        disabled={!request.individualAccommodation || this.state.checkDayCount}
                        id='howManyDaysStay'
                      />
                    </div>
                  </div>
                </div>
                {
                                    parseInt(
                                      request.calculatedAmount.individualAccommodationAmount) > 0
                                      ? (
                                        <div style={{ textAlign: 'center' }}>
                                          <span
                                            className="text-success text-success-span" id='payment'
                                          >
                                            <b>
                                              {request.calculatedAmount.individualAccommodationAmount}
                                              {' '}
                                              {getCurrencySymbol(
                                                request.calculatedAmount.abroadCurrency)}
                                            </b>
                                            {' '}
                                            {t("youWillNetIndividualAccommodation")}
                                            <br />
                                          </span>
                                        </div>
                                      )
                                      : null
                                }
                <div className="clearfix" />
              </div>
            )
            : null}
        </div>
      </div>
    );
  }
}

export default withNamespaces()(RequestItem);



// WEBPACK FOOTER //
// ./src/pages/travel-expense/form/index.js